import { AppState, AppActionTypes, LOAD_APP, SHOW_APP, TOGGLE_MENU, SET_BREADCRUMB_STACK, SET_MENU_IS_EXPANDED, SET_GLOBAL_ERROR, SET_PAGE_ERROR } from "./types";

const lastMenuExpansionStatus = localStorage.getItem("menu-expanded") != "0";

const initialState: AppState = {
    loading: true,
    menuItems: [],
    menuIsExpanded: lastMenuExpansionStatus,
    breadcrumbStack: [{ title: "Home" }],
    errors: {},
    user: {
        name: "",
        roles: [],
        isDeveloper: false,
    }
}

export function appReducer(
    state = initialState,
    action: AppActionTypes
): AppState {
    switch (action.type) {
        case LOAD_APP:
            return {
                ...state,
                loading: true,
                user: action.user,
            }

        case SHOW_APP:
            return {
                ...state,
                loading: false,
                menuItems: action.menuItems
            }

        case TOGGLE_MENU:
            localStorage.setItem("menu-expanded", state.menuIsExpanded ? "0" : "1");

            return {
                ...state,
                menuIsExpanded: !state.menuIsExpanded
            }

        case SET_BREADCRUMB_STACK:
            return {
                ...state,
                breadcrumbStack: action.breadcrumbStack
            }

        case SET_MENU_IS_EXPANDED:
            localStorage.setItem("menu-expanded", action.value ? "1" : "0");

            return {
                ...state,
                menuIsExpanded: action.value
            }

        case SET_GLOBAL_ERROR:
            return {
                ...state,
                errors: {
                    ...state.errors,
                    global: action.error
                }
            }

        case SET_PAGE_ERROR:
            return {
                ...state,
                errors: {
                    ...state.errors,
                    page: action.error
                }
            }

        default:
            return state;
    }
}